import { render, staticRenderFns } from "./tcplayerw.vue?vue&type=template&id=4e5029ad"
import script from "./tcplayerw.vue?vue&type=script&lang=js"
export * from "./tcplayerw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports